import React from "react";
import Loader from "./Loader";

const ActionProvider = ({ createChatBotMessage, setState, children }) => {
    async function sendMessage(message) {
        try {
            const cliente_id = sessionStorage.getItem("client_id");
            const usuario_id = sessionStorage.getItem("user");
            const usuario_correo = sessionStorage.getItem("email");
            const requestData = {
                cliente_id,
                usuario_id,
                usuario_correo,
            };
            const session_id = sessionStorage.getItem("session_id");

            const response = await fetch(
                `https://api-ia.atentus.com/agents/atbotv1/1/invoke-agent/?prompt=${message}&session_id=${session_id}`,
                {
                    method: "POST",
                    headers: {
                        authorization:
                            "f34f9c7ab0c5c865968f40c90488c4ffb6dbe850",
                        "Content-Type":
                            "application/x-www-form-urlencoded;charset=UTF-8",
                        Referer: "http://localhost:3000/",
                    },
                    body: new URLSearchParams(requestData),
                }
            );

            if (response.status === 200) {
                const json = await response.json();
                return json.result;
            }
        } catch (err) {
            console.error(err);
            return "";
        }
    }

    const handleHello = async (message) => {
        const btn = document.getElementsByClassName(
            "react-chatbot-kit-chat-btn-send"
        );
        if (btn.length) {
            btn[0].disabled = true;
        }
        const initialMessage = createChatBotMessage(<Loader />);
        setState((prev) => ({
            ...prev,
            messages: [...prev.messages, initialMessage],
        }));
        const botMessage = await sendMessage(message);
        if (btn.length) {
            btn[0].disabled = false;
        }
        const newBotMessage = createChatBotMessage(botMessage);

        setState((prev) => {
            const copy = [...prev.messages];
            copy[copy.length - 1] = newBotMessage;
            localStorage.setItem("chat_messages", JSON.stringify(copy));
            return {
                ...prev,
                messages: [...copy],
            };
        });
    };
    return (
        <div>
            {React.Children.map(children, (child) => {
                return React.cloneElement(child, {
                    actions: { handleHello },
                });
            })}
        </div>
    );
};

export default ActionProvider;
